import styles from "./HealthBar.module.css";

interface HealthBarProps {
  score: number;
}

function getColor(score: number): string {
  if (score > 90) return "var(--health-green)";
  if (score >= 75) return "var(--health-yellow)";
  return "var(--health-red)";
}

export function HealthBar({ score }: HealthBarProps) {
  const pct = Math.max(0, Math.min(100, score));
  const color = getColor(pct);
  return (
    <div className={styles.container} title={`${pct}%`}>
      <div className={styles.track}>
        <div className={styles.bar} style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
      <span className={styles.label} style={{ color }}>{pct}%</span>
    </div>
  );
}
